import React from "react";
import { STATUS_META, PROCESS_TIMES, ptColor } from "@/lib/api";

export const textOn = (hex) => { const h = (hex || "#e2e8f0").replace("#", ""); const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16); const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255; return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? "#0f172a" : "#ffffff"; };

export const StatusBadge = ({ status, className = "" }) => {
  const bg = STATUS_META[status]?.color || "#e2e8f0";
  return (
    <span
      data-testid={`status-badge-${String(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      style={{ backgroundColor: bg, color: textOn(bg), borderColor: bg === "#ffffff" ? "#94a3b8" : bg }}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-medium ${className}`}
    >
      {status}
    </span>
  );
};

export const ProcessTimeBadge = ({ job, className = "" }) => {
  const idx = PROCESS_TIMES.findIndex((p) => p.value === job?.process_time);
  const pt = PROCESS_TIMES[idx];
  if (!pt) return null;
  return (
    <span
      data-testid={`process-time-badge-${job.job_number}`}
      title={`Process time: ${pt.value} — ${pt.turnaround}${pt.surcharge ? ` (+${pt.surcharge}%)` : ""}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-bold uppercase tracking-wide ${ptColor(idx)} ${className}`}
    >
      {pt.value}{pt.value !== pt.turnaround && ` • ${pt.turnaround}`}
    </span>
  );
};

export const AgentBadge = ({ job, className = "" }) => {
  if (!job?.agent_id) return <ProcessTimeBadge job={job} className={className} />;
  return (
    <>
      <span
        data-testid={`agent-badge-${job.job_number}`}
        title={`Agent order: ${job.agent_name || ""}`}
        className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-bold uppercase tracking-wide bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-950/70 dark:text-amber-300 dark:border-amber-800 ${className}`}
      >
        Agent
      </span>
      <ProcessTimeBadge job={job} />
    </>
  );
};
